module.exports = __webpack_public_path__ + "images/next/ja/icon_arrow-cfe8d42d2aeeb84606bdf72efa6c26e8.png";